<template>
    <div>
      <el-tree 
        :data="data" 
        :props="defaultProps" 
        node-key="id"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
        show-checkbox
        ref="tree"
      >
      </el-tree>
      <el-button @click="manually_set">Manuall Set</el-button>
    </div>
</template>

<script>
  export default {
    name: 'test',
    data() {
      return {
        data: [{
          label: '一级 1',
          level: 'recordgroup',
          id: 1,
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          level: 'recordgroup',
          id: 2,
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          level: 'recordgroup',
          id: 3,
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      };
    },

    methods: {
      manually_set () {
        this.$refs.tree.setCheckedNodes([{
          id: 1,
          label: '一级 1',
        }, {
          id: 2,
          //label: '三级 1-1-1'
        }]);
      },
      handleNodeClick(data) {
        console.log('node clicked:', data);
      },
      handleCheckChange(data, checked, indeterminate) {
        console.log('check changed:', data, checked, indeterminate);
        console.log('checked nodes: ', this.$refs.tree.getCheckedNodes());
        console.log('checked keys: ', this.$refs.tree.getCheckedKeys());
      },
    }
  };
</script>

<style>


</style>
